import { render, staticRenderFns } from "./faceMonitor.vue?vue&type=template&id=f5a0ca76&"
import script from "./faceMonitor.vue?vue&type=script&lang=js&"
export * from "./faceMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports